import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';

import { IBaseTableRepeater, ITableRepeater, RepeaterElementType, Table } from 'dspx-core';

@Component({
  selector: 'dspx-table-repeater-custom',
  templateUrl: './dspx-table-repeater-custom.component.html',
  styleUrl: './dspx-table-repeater-custom.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class DspxTableRepeaterCustomComponent implements AfterViewInit, OnInit {

  @Input() sectionLabel: string;
  @Input() repeater: IBaseTableRepeater;
  @Input() renderItemsAsSeparateFieldTypes: boolean;
  @Input() repeaterLayout: string = 'plain';
  @Input() hideCustomHeaderWhenExpanded: boolean = false;
  @Input() hideCustomSubHeaderWhenExpanded: boolean = false;

  @Output() onInitialiseCompleted: EventEmitter<ITableRepeater> = new EventEmitter<ITableRepeater>();

  @ViewChild(Table)
  private table: Table;

  private searchInput: HTMLInputElement;

  headerQuestions: { field: string, header: string }[];

  RepeaterElementType = RepeaterElementType; // workaround to make the enum accessible from the Angular HTML template

  ngOnInit(): void {
    this.headerQuestions = this.repeater.viewModel.orderedQuestions.map(question => ({ field: question.key, header: question.label }));
  }

  ngAfterViewInit(): void {
    this.onInitialiseCompleted.emit({
      isEditingItem: itemHeaderViewModel => this.table.isRowExpanded(itemHeaderViewModel),
      toggleItemEditingStatus: itemHeaderViewModel => this.table.toggleRow(itemHeaderViewModel),
      reapplySearch: () => this.onExecuteSearch(this.searchInput),
      clearSearch: () => this.onClearSearch(this.searchInput)
    });
  }

  onClearSearch(searchInput: HTMLInputElement): void {
   
  }

  onExecuteSearch(searchInput: HTMLInputElement): void {
    
  }

  getHeaderHtml(itemIndex): string {
    if (this.repeater.getCustomItemHeaderHtml) {
      return this.repeater.getCustomItemHeaderHtml(this.repeater.getItemConfig(itemIndex), itemIndex);
    }
    return '';
  }

  getSubHeaderHtml(itemIndex): string {
    if (this.repeater.getCustomItemSubHeaderHtml) {
      return this.repeater.getCustomItemSubHeaderHtml(this.repeater.getItemConfig(itemIndex), itemIndex);
    }
    return '';
  }

  isQuestionToBeIgnored(itemConfig): boolean {
    return itemConfig.key.includes('-exists') || itemConfig.key.includes('-notassessed');
  }
}
